import { render, staticRenderFns } from "./RetornarItemModal.vue?vue&type=template&id=1fc46898&scoped=true"
import script from "./RetornarItemModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RetornarItemModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RetornarItemModal.vue?vue&type=style&index=0&id=1fc46898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc46898",
  null
  
)

export default component.exports